import { defineMessages } from "react-intl";

export default defineMessages({
  globalHeader: {
    id: `globalHeader`,
    defaultMessage: "SGate"
  }
});
